var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2138 8.16389C12.4148 8.16389 12.6187 8.07628 12.7711 7.90543C13.0763 7.56341 13.0763 6.99787 12.7711 6.65585L7.06074 0.255857C6.91335 0.0906707 6.70542 -0.00260533 6.50342 -0.00260536C6.30331 -0.00260538 6.10387 0.0790263 5.94609 0.255857L0.243513 6.64764C-0.0759534 6.98463 -0.0800542 7.56352 0.225114 7.90554C0.530282 8.24756 1.03489 8.24756 1.34005 7.90554L1.34024 7.90533L6.49321 2.11858L11.6567 7.9056C11.8094 8.07677 12.0133 8.16406 12.214 8.16406L12.2138 8.16389Z",
    fill: "#F66700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.d0924f1c2b844150c175a565c3e216e0.svg";
export { ForwardRef as ReactComponent };